<template>
    <div class="editor">
      <editor v-model="editorValue" :init="init"></editor>
      <div class="d-flex justify-content-end text-secondary">{{ currentLength +' / '+ maxLength }}</div>
    </div>
  </template>
  <script>
  import tinymce from 'tinymce/tinymce.js'
  // import 'tinymce/models/dom'; (TinyMCE 6)
  
  // 外觀
  import 'tinymce/skins/ui/oxide/skin.css'
  import 'tinymce/themes/silver'
  
  // Icon
  import 'tinymce/icons/default'
  
  // 用到的外掛
  import 'tinymce/plugins/emoticons'
  import 'tinymce/plugins/emoticons/js/emojis.js'
  import 'tinymce/plugins/table'
  import 'tinymce/plugins/quickbars'
  
  // 語言包
  import 'tinymce-i18n/langs5/vi.js'
  // import 'tinymce-i18n/langs/zh_Hans.js' (TinyMCE 6 的簡體中文)
  
  // TinyMCE-Vue
  import Editor from '@tinymce/tinymce-vue'
  
  export default {
    components: {
      Editor,
    },
    props: {
      value: {
        type: String,
        default: '',
      },
      plugins: {
        type: [String, Array],
        default: 'emoticons table',
      },
      toolbar: {
        type: [String, Array],
        default:
          'undo redo | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | outdent indent  | axupimgs | removeformat | emoticons',
      },
      lang: {
        type: String,
        default: 'vi',
      },
      maxLength: {
        type: [String, Number],
        default: 3000,
      }
    },
    data() {
      return {
        init: {
          language: this.lang,
          height: 300,
          menubar: false,
          content_css: false,
          skin: false,
          plugins: this.plugins,
          toolbar: this.toolbar,
          quickbars_insert_toolbar: false,
          branding: false,
          fontsize_formats:
          "8px 9px 10px 11px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
          content_style: `
            body {
              p {
                margin: 0;
              }
            }
          `,
          setup: (editor) => {
            this.handleEditorInit(editor);
          },
          max_chars: this.maxLength,
        },
        editorValue: this.value,
      }
    },
    mounted() {
      tinymce.init({})
    },
    watch: {
      value(newValue) {
        this.editorValue = newValue
      },
      editorValue(newValue) {
        this.$emit('input', newValue)
      },
    },
    computed: {
      currentLength() {
        if (!this.editorValue) return 0;
        const div = document.createElement('div');
        div.innerHTML = this.editorValue;
        const textContent = div.textContent || div.innerText || '';
        return textContent.length;
      },
    },
    methods: {
      stripHtml(html) {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
      },
      handleEditorInit(editor) {
        editor.on('BeforeSetContent', (e) => {
          if (e.content) {
            const currentContent = editor.getContent();
            const newPlainText = this.stripHtml(currentContent + e.content);
            if (newPlainText.length > this.maxLength) {
              e.preventDefault();
            }
          }
        });

        editor.on('PastePreProcess', (e) => {
          const currentContent = editor.getContent();
          const newPlainText = this.stripHtml(currentContent + e.content);
          if (newPlainText.length > this.maxLength) {
            e.preventDefault();
          }
        });

        editor.on('keydown', (e) => {
          const content = editor.getContent();
          const plainText = this.stripHtml(content);
          const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'];
          if (e.ctrlKey || e.metaKey) return;
          if (plainText.length >= this.maxLength && !allowedKeys.includes(e.key)) {
            e.preventDefault();
          }
        });

        editor.on('NodeChange SetContent Undo Redo', () => {
          const content = editor.getContent();
          const plainText = this.stripHtml(content);

          if (plainText.length > this.maxLength) {
            let bookmark = null;
            try {
              if (editor.selection && editor.selection.getBookmark) {
                bookmark = editor.selection.getBookmark(2, true);
              }
            } catch (err) {
              bookmark = null;
            }

            let truncated = content;
            while (this.stripHtml(truncated).length > this.maxLength) {
              truncated = truncated.slice(0, -1);
            }

            try {
              if (editor.undoManager && editor.undoManager.transact) {
                editor.undoManager.transact(() => {
                  editor.setContent(truncated);
                });
              } else {
                editor.setContent(truncated);
              }
            } catch (err) {
              editor.setContent(truncated);
            }

            try {
              if (bookmark && editor.selection && editor.selection.moveToBookmark) {
                editor.selection.moveToBookmark(bookmark);
              }
            } catch (err) {
            }
          }
        });

        editor.on('init', () => {
          footerEl = createFooter();
        });
      },
    },
  }
  </script>
  